import CybsMenuButton from '@cybs-ui/components/lib/menu-button';
import React from 'react';
import { connect } from 'react-redux';
import { getLanguageDetails } from '../../../../../commons/ui-commons';
import { handleSampleCodeSelection } from '../js/live-console';
import zIndex from '@material-ui/core/styles/zIndex';
import '../css/sample-code-dropdown.css'


var languages = getLanguageDetails();
var selectedSampleCode = {'label':'LiveConsole', 'value':'LiveConsole'};

class SampleCodeDropDownInLiveConsole extends React.Component
{


   render()
   {
    selectedSampleCode = (this.props.selectedSampleCode == undefined) ?  {
        'label':'LiveConsole',
        'value':'LiveConsole'
    }: this.props.selectedSampleCode;

    var buttonDivStyle = {};   
    if(selectedSampleCode.label === 'LiveConsole'){
        buttonDivStyle = {marginRight:'5px', marginTop: '5px', marginBottom: '5px', marginLeft: 'auto',zIndex:'5'}; 
       }
       else{
        buttonDivStyle = {marginRight:'5px', marginTop: '5px', marginBottom: '5px', marginLeft: '0px',zIndex:'5'}; 
       }
       return(
        <div className = "sample-code-dropdown" style={buttonDivStyle}>
                                                {
                                                (!this.props.isClientSideApi) &&
                                                <CybsMenuButton
                                                    buttonProps={{
                                                        colorScheme: 'secondary',
                                                        label: 'See Language Sample',
                                                        onButtonClick: (event, open) => {},
                                                        onButtonKeyDown: (event, open) => {},
                                                        variant: 'split',
                                                        className : "border_color_theme_primary"
                                                        
                                                    }}
                                                    dataTest="switch-language"
                                                    items={languages.slice(1,7)}
                                                    onSelect={handleSampleCodeSelection}
                                                    className = "border_color_theme_primary"
                                                    selectedItem={[selectedSampleCode]}
                                                    width="400px"
                                                    />
                                                }
        </div> 
       );

    }
}
function mapStateToProps(state){

    return{      
        isClientSideApi: state.lhsReducer.isClientSideApi,
        selectedSampleCode: state.examplesReducer.selectedSampleCode
    };
   
}

export default connect(mapStateToProps)(SampleCodeDropDownInLiveConsole);